/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style3 = require('antd/lib/table/style');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style4 = require('antd/lib/tabs/style');

var _tabs = require('antd/lib/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _reactRouter = require('react-router');

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _reactFreeScrollbar = require('react-free-scrollbar');

var _reactFreeScrollbar2 = _interopRequireDefault(_reactFreeScrollbar);

var _tool = require('util/tool');

var _config = require('util/config');

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabPane = _tabs2.default.TabPane;

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.onChange = function (pagination, filters, sorter) {
      _this.setState({
        page: pagination.current,
        sort: sorter.order && (sorter.order.indexOf('des') > -1 ? 'desc' : 'asc') || '',
        sortKey: sorter.field || ''
      }, function () {
        _this.fetch();
      });
    };

    _this.search = function (o) {
      _this.setState({
        versionCode: o.keyWord,
        page: 1
      }, function () {
        _this.fetch();
      });
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //     console.log('Received values of form: ', values);
      //   }
      // });
    };

    _this.callback = function (key) {
      console.log(key);
    };

    _this.getPagedDeviceUpgradeRecordList = function () {
      var _this$state = _this.state,
          paramsCar = _this$state.paramsCar,
          deviceCode = _this$state.deviceCode;

      (0, _tool.http)(_config.apiJson.getPagedDeviceUpgradeRecordList, (0, _extends3.default)({}, paramsCar, { deviceId: deviceCode })).then(function (res) {
        console.log(res);
        // this.setState((prevState) =>{
        //   delete prevState.carUpdate;
        //   return prevState;
        // })
        _this.setState({
          carUpdate: res
        });
      });
    };

    _this.handleSubmitCar = function () {};

    _this.searchCar = function (val) {
      _this.setState({
        deviceCode: val.keyWord,
        page: 1
      }, function () {
        _this.getPagedDeviceUpgradeRecordList();
      });
    };

    _this.onChangeCar = function (pagination, filters, sorter) {
      var a = {
        page: pagination.current,
        rows: 10
      };
      _this.setState({
        paramsCar: a
        // sort: (sorter.order&&(sorter.order.indexOf('des') > -1 ? 'desc' : 'asc')) || '',
        // sortKey: sorter.field || ''
      }, function () {
        _this.getPagedDeviceUpgradeRecordList();
      });
    };

    _this.state = {
      page: 1,
      records: [],
      versionCode: '',
      sort: '',
      sortKey: '',
      carUpdate: [],
      deviceCode: '',
      paramsCar: {
        page: 1,
        rows: 10
      }
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'updateRoute',
    value: function updateRoute(id, rid, upgradeTaskStatus) {
      this.props.router.push({
        pathname: '/remote/' + id + '/recordsDetail/' + rid
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // const {params} = this.props
      // let options = {productId: params.id}
      this.fetch();
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this2 = this;

      var _state = this.state,
          page = _state.page,
          versionCode = _state.versionCode;
      var params = this.props.params;
      var id = params.id;


      (0, _tool.http)(_config.apiJson.getPageUpgradeList, {
        page: page,
        versionCode: versionCode,
        productId: id
      }).then(function (res) {
        _this2.setState({
          records: res
        });
      });
    }
    // ----------------------------------------------------------------

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var params = this.props.params;
      var _state2 = this.state,
          records = _state2.records,
          page = _state2.page,
          carUpdate = _state2.carUpdate,
          paramsCar = _state2.paramsCar;

      var list = records;
      var pagination = {
        defaultCurrent: 1,
        current: page,
        total: list.total,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return '\u5171\u8BA1 ' + total + ' \u6761';
        },
        showQuickJumper: true
      };
      var paginationCar = {
        defaultCurrent: 1,
        current: paramsCar.page,
        total: carUpdate.total,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return '\u5171\u8BA1 ' + total + ' \u6761';
        },
        showQuickJumper: true
      };
      var productId = params.id;

      var columns = [{
        title: '操作时间',
        dataIndex: 'createTime'
      }, {
        title: '升级总数',
        dataIndex: 'deviceCount',
        render: function render(text, record) {
          return '' + text;
        }
      }, {
        title: '升级成功',
        dataIndex: 'successCount',
        render: function render(text, record) {
          return record.upgradeTaskStatus == 1 ? '--' : text;
        }
      }, {
        title: '升级失败',
        dataIndex: 'failedCount',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {
            style: { color: "red" }
          }, void 0, record.upgradeTaskStatus == 1 ? '--' : text);
        }
      }, {
        title: '升级状态',
        dataIndex: 'upgradeTaskStatus',
        render: function render(text, record) {
          return _tool.filter.ProductUpgradeStatus(text);
        }
      }, {
        title: '更新内部版本号',
        dataIndex: 'versionCode',
        render: function render(text, record) {
          return '' + text;
        }
      }, {
        title: '更新外部版本',
        dataIndex: 'outVersion',
        render: function render(text, record) {
          return '' + (text ? text : '');
        }
      }, {
        title: '更新方式',
        dataIndex: 'upgradeRange',
        render: function render(text) {
          return text == 1 ? '全部设备' : '指定ID';
        }
      }, {
        title: '更新要点',
        dataIndex: 'remark',
        key: 'remark',
        ellipsis: true
      }, {
        title: '推送时间',
        dataIndex: 'pushTime',
        width: 100
      }, {
        title: '操作员',
        dataIndex: 'creator'
      }, {
        title: '操作',
        render: function render(text, record) {
          return (0, _jsx3.default)('span', {
            className: 'device-table-btn-group'
          }, void 0, (0, _jsx3.default)('a', {
            href: 'javascript:void(0);',
            onClick: function onClick() {
              _this3.updateRoute(productId, record.rid, record.upgradeTaskStatus);
            },
            'data-status': 'editVisibale'
          }, void 0, (0, _jsx3.default)('img', {
            src: require('./info.png'),
            alt: ''
          })));
        }
      }];
      var columnsCar = [{
        title: 'VIN',
        dataIndex: 'deviceId'
      }, {
        title: '操作时间',
        dataIndex: 'createTime'
      }, {
        title: '升级状态',
        dataIndex: 'upgradeStatus',
        render: function render(text, record) {
          return _tool.filter.ProductUpgradeStatus(text);
        }
      }, {
        title: '更新内部版本',
        dataIndex: 'versionCode'
      }, {
        title: '更新外部版本',
        dataIndex: 'outVersion'
      }, {
        title: '更新方式',
        dataIndex: 'upgradeRange',
        render: function render(text) {
          return text == 1 ? '全部设备' : '指定ID';
        }
      }, {
        title: '推送时间',
        dataIndex: 'upgradeTime',
        width: 100
      }, {
        title: '操作员',
        dataIndex: 'creator'
      }];

      var data = [];
      var rows = list.rows ? list.rows : [];
      var deviceRows = [];
      var gg = carUpdate.rows ? carUpdate.rows : [];
      gg.forEach(function (item, index) {
        var a = (0, _extends3.default)({}, item, { key: index });
        deviceRows.push(a);
      });
      // console.log(deviceRows)
      rows.map(function (item, index) {
        var o = {
          key: index,
          deviceCount: item.deviceCount,
          successCount: item.successCount,
          failedCount: item.failedCount,
          upgradeTaskStatus: item.upgradeTaskStatus,
          createTime: item.createTime,
          createTimeStr: _tool.tool.formatTime(item.createTime.replace(/\-/g, '/')),
          upgradeMode: item.upgradeMode,
          outVersion: item.outVersion,
          versionCode: item.versionCode,
          upgradeRange: item.upgradeRange,
          packageVerifyValue: item.packageVerifyValue,
          remark: item.remark,
          pushTime: item.pushTime,
          pushTimeStr: _tool.tool.formatTime(item.pushTime.replace(/\-/g, '/')),
          creator: item.creator,
          rid: item.id,
          productName: item.productName,
          factoryName: item.factoryName,
          upgradeTime: item.upgradeTime
        };

        data.push(o);
      });

      return (0, _jsx3.default)('div', {
        className: 'remote-records'
      }, void 0, (0, _jsx3.default)(_tabs2.default, {
        defaultActiveKey: '1',
        onChange: this.callback
      }, void 0, (0, _jsx3.default)(TabPane, {
        tab: '\u5347\u7EA7\u4EFB\u52A1\u72B6\u6001'
      }, '1', (0, _jsx3.default)('div', {
        className: 'search'
      }, void 0, (0, _jsx3.default)(_search2.default, {
        onSubmit: this.handleSubmit.bind(this),
        search: this.search,
        message: '\u8F93\u5165\u56FA\u4EF6\u7248\u672C\u53F7\u641C\u7D22'
      })), (0, _jsx3.default)(_table2.default, {
        className: 'list',
        columns: columns,
        dataSource: data,
        pagination: pagination,
        onChange: this.onChange
      })), (0, _jsx3.default)(TabPane, {
        tab: '\u8F66\u8F86\u5347\u7EA7\u7EAA\u5F55'
      }, '2', (0, _jsx3.default)('div', {
        className: 'search'
      }, void 0, (0, _jsx3.default)(_search2.default, {
        onSubmit: this.handleSubmitCar.bind(this),
        search: this.searchCar,
        message: '\u8BF7\u8F93\u5165\u8F66\u8F86VIN\u7801\u67E5\u8BE2'
      })), deviceRows.length > 0 ? (0, _jsx3.default)(_table2.default, {
        className: 'list',
        columns: columnsCar,
        dataSource: carUpdate.rows,
        pagination: paginationCar,
        onChange: this.onChangeCar
      }) : (0, _jsx3.default)('div', {
        className: 'no-data'
      }, void 0, (0, _jsx3.default)('div', {
        style: { color: '#bfbfbf', fontSize: 18, display: 'flex', alignItems: 'center', fontWeight: "bold" }
      }, void 0, (0, _jsx3.default)('img', {
        src: require('./search.png'),
        alt: ''
      }), '\u8BF7\u8F93\u5165\u8F66\u8F86VIN\u7801\u8FDB\u884C\u67E5\u8BE2')))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: '', // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/remote/records/index.jsx
// module id = 1503
// module chunks = 0